import { useEffect, useRef } from 'react';
import { SwitchTransition, Transition } from 'react-transition-group';
import { useLocation } from 'react-router-dom';

import { gsap } from 'gsap';

import { getPagefromLocation } from '../utils/utils';
import { pageInitState } from '../utils/config';

let transPage = "";

const TransitionComponent = ({ children, appLoaded, loadingOn, pageCurrent, setPageCurrent, pageChangeOn, setPageChangeOn, pageOn, setPageOn, errorObj }) => {
  const pageCurrentRef = useRef(""); 

  const location = useLocation();
  // const pageNow = (!!errorObj) ? 'error' : ((location.pathname.substring(1) === "") ?  'home' : location.pathname.substring(1));
  transPage = getPagefromLocation(location.pathname, !!errorObj);
  const key = transPage;
  
  console.log(`TransitionComponent: [pageCurrent: ${pageCurrent}] [pageCurrentRef: ${pageCurrentRef.current}]`);

  ////////// App is loaded
  useEffect(() => {
    console.log(`TransitionComponent: useEffect [appLoaded: ${appLoaded}], [transPage: ${transPage}]`);

    if(appLoaded) {
      setPageCurrent(transPage); // When app is first loading, set currunt page
    }
  }, [appLoaded, setPageCurrent]);

  ////////// Loading is done
  useEffect(() => {
    console.log(`TransitionComponent: useEffect [loadingOn: ${loadingOn}], [transPage: ${transPage}]`);

    // When App is loaded with pages other than home page, play logo showing animation
    if(!loadingOn) {
      if(transPage !== 'home') { 
        gsap.timeline()
        .to('.part.header .container-in', {duration: 0.3, opacity: 1, ease: 'power1.in'})
        .addLabel('t')
        .to('.logo-mask' , {duration: 0.7, strokeDashoffset: 0, stagger: 0.3, ease: 'none'})
        .to('.logo-path-a', {duration: 0.1, opacity: 1})
        .to('.name-menu__name', {duration: 0.5, opacity: 1, yPercent: 0, ease: 'power1.out',}, `t+=${0.3}`)
        .to('.menu-bar', {duration: 0.3, opacity: 1, yPercent: 0, ease: 'power1.out', stagger: -0.2,}, `t+=${0.3}`)
      }
    }
  }, [loadingOn]);


  ////////// Set pageCurrentRef when a component is entered
  useEffect(() => {
    pageCurrentRef.current = pageCurrent;
  }, [pageCurrent])


  const onEnter = (node) => {
    console.log(`TransitionComponent: onEnter: [pageCurrent: ${pageCurrent}] [pageCurrentRef: ${pageCurrentRef.current}], [transPage: ${transPage}]`, pageChangeOn, pageOn, location);

    // setPageChangeOn({home: false, web: false, email: false, graphic: false, photo: false, retouch: false, coming: false, [page]: true});
    // setPageOn({home: false, web: false, email: false, graphic: false, photo: false, retouch: false, coming: false});
    setPageChangeOn({...pageInitState, [transPage]: true});
    setPageOn({...pageInitState});

    gsap.set(node, { zIndex: 100000 });
    gsap.to('.part.header .container-in', {duration: 0.3, opacity: 0, ease: 'power1.in'}); // header hide
    
    // gsap.killTweensOf(node);
    // gsap.set(node, { autoAlpha: 0 });
    // gsap
    //   .timeline({ paused: true })
    //   .to(node, { autoAlpha: 1, duration: 0.2 })
    //   .play();
  }

  const onEntered = (node) => {
    console.log(`TransitionComponent: onEntered: [pageCurrent: ${pageCurrent}] [pageCurrentRef: ${pageCurrentRef.current}], [transPage: ${transPage}]`, pageChangeOn, pageOn, location);

    setPageCurrent(transPage);
    gsap.to('.part.header .container-in', {duration: 0.3, opacity: 1, ease: 'power1.in'}); // header show
  }

  const onExit = (node, pageCurrent) => {
    console.log('TransitionComponent: onExit: [pageCurrent:' + pageCurrent + '] [pageCurrentRef: ' + pageCurrentRef.current + '] ', '[transPage:' + transPage + ']', pageChangeOn, pageOn, location);

    // gsap.killTweensOf(node);
    // gsap
    //   .timeline({ paused: true })
    //   .to(node, { autoAlpha: 0, duration: 0.2 })
    //   .play();
  }

  const onExited = (node, pageCurrent, key) => {
    console.log('TransitionComponent: onExited: [pageCurrent: ' + pageCurrent + '] [pageCurrentRef: ' + pageCurrentRef.current + '] ', '[transPage:' + transPage + ']', pageChangeOn, pageOn, location);

    gsap.set('.page-'+pageCurrentRef.current, { clearProps: 'zIndex'});
  }


  return (
    <SwitchTransition mode="in-out">
      <Transition
        key={key}
        timeout={{ enter: 1500, exit: 10 }}
        onEnter={onEnter}
        onEntered={onEntered}
        onExit={(node) => onExit(node, pageCurrent)}
        onExited={(node) => onExited(node, pageCurrent, key)}
        // mountOnEnter
        // unmountOnExit
      >
        {children}
      </Transition>
    </SwitchTransition>
  );
};

export default TransitionComponent;
